import React, {memo, useState} from "react";
import {useTranslation} from "react-i18next";
//local
import SubHeading from "components/SubHeading";
import {showError, showSuccess} from "helpers/notifications.helper";
import {ButtonTransparent} from "components/buttons/ButtonTransparent";
import {CustomCheckpointModal} from "components/modals/CustomCheckpointModal";
import {ConfirmModal} from "components/ConfirmModal";
import {IconLabel, IconPlus, IconCog, IconCheckpoint} from "components/icons";

const CustomCheckpointsSettings = memo(
  ({markings, isAdminOwner, getMarkings, onCreate, onUpdate, onDelete}) => {
    const {t} = useTranslation();

    const [selectedMarking, setSelectedMarking] = useState(null);
    const [loadingChangeMarking, setLoadingChangeMarking] = useState(false);

    const MarkingRow = ({marking}) => (
      <div key={marking.id} className="organization-settings__markings-row">
        <IconCheckpoint name={marking.name} />
        <span className="ml-2 mr-2">{marking.description}</span>
        <ButtonTransparent
          addClass="__rotate-on-hover"
          iconButton
          color="black"
          icon={<IconCog />}
          onIconClick={() =>
            isAdminOwner
              ? setSelectedMarking(marking)
              : showError("WRONG_PRIVILEGES_ONLY_OWNER_ADMIN")
          }
        />
      </div>
    );
    const handleSaveMarking = async ({name, description}) => {
      try {
        setLoadingChangeMarking(true);
        const isUpdating = !!selectedMarking?.id;
        const values = {name, description};
        isUpdating ? await onUpdate(selectedMarking.id, values) : await onCreate(values);
        setSelectedMarking(null);
        showSuccess(isUpdating ? t("SUCCESSFULLY_UPDATED") : t("SUCCESSFULLY_CREATED"));
        getMarkings();
      } finally {
        setLoadingChangeMarking(false);
      }
    };

    const handleRemoveMarking = () =>
      ConfirmModal({
        title: t("WANT_DELETE_OUR_CHECKPOINTS_LABEL"),
        text: t("CANT_DELETE_OUR_CHECKPOINTS_LABEL"),
        type: "warning",
        onOk: () => {
          setLoadingChangeMarking(true);
          onDelete(selectedMarking.id)
            .then(() => {
              setSelectedMarking(null);
              showSuccess(t("SUCCESSFULLY_REMOVED"));
              getMarkings();
            })
            .finally(() => setLoadingChangeMarking(false));
        },
      });

    return (
      <React.Fragment>
        <div className="organization-settings__markings">
          <SubHeading
            title="SETTINGS_ORGANIZATION_CUSTOM_CHECKPOINTS"
            icon={<IconLabel />}
          />
          <div className="fz-14 mt-2">
            {t("SETTINGS_ORGANIZATION_CUSTOM_CHECKPOINTS_DESCRIPTION")}
          </div>
          {!!markings?.length && (
            <div className="organization-settings__markings-list">
              {markings.map((marking) => (
                <MarkingRow key={marking.id} marking={marking} />
              ))}
            </div>
          )}

          {isAdminOwner && (
            <ButtonTransparent
              addClass="organization-settings__markings__add-button"
              name="ADD"
              small
              rounded
              color="black"
              icon={<IconPlus />}
              onClick={() =>
                isAdminOwner
                  ? setSelectedMarking({})
                  : showError("WRONG_PRIVILEGES_ONLY_OWNER")
              }
            />
          )}
        </div>
        {selectedMarking && (
          <CustomCheckpointModal
            marking={selectedMarking}
            onSave={handleSaveMarking}
            onRemove={handleRemoveMarking}
            onClose={() => setSelectedMarking(null)}
            loading={loadingChangeMarking}
          />
        )}
      </React.Fragment>
    );
  }
);

export default CustomCheckpointsSettings;
